import React, { useEffect, useState } from 'react';
import { useUserAuth } from '../../context/UserAuthContext';
import { API } from '../../api';
import { fmtMoney } from '../../utils/media';
import { Wallet, Download, CheckCircle2, ShieldAlert, ArrowRight, User, Banknote, ShieldCheck } from 'lucide-react';

export function AccountWallet() {
  const { authHeader } = useUserAuth();
  const [balance, setBalance] = useState(0);
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState('havale');
  const [txId, setTxId] = useState('');

  useEffect(() => {
    API.get('/user/wallet/balance', { headers: authHeader() }).then(r => setBalance(r.data.balance));
  }, []);

  const submitDeposit = async (e) => {
    e.preventDefault();
    if (!amount || !txId) return;
    try {
      await API.post('/user/wallet/deposit', { amount: Number(amount), method, tx_id: txId }, { headers: authHeader() });
      alert('Bakiye yükleme talebiniz başarıyla alındı. Yönetici onayından sonra bakiyenize eklenecektir.');
      setAmount(''); setTxId('');
    } catch {
      alert('Bir hata oluştu.');
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="font-display text-2xl font-black text-white mb-6">Cüzdanım & Bakiye</h2>
      <div className="rounded-3xl border border-[#e4b44e]/20 bg-gradient-to-br from-[#08080b] via-[#08080b] to-[#08080b] p-8 md:p-10 mb-8 text-center relative overflow-hidden shadow-[0_30px_80px_-40px_rgba(228,180,78,0.2)]">
        <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[#e4b44e]/10 blur-3xl" />
        <Wallet className="w-10 h-10 text-[#f4d896] mx-auto mb-4 opacity-80" />
        <div className="text-sm font-bold tracking-[0.2em] text-[#e4b44e]/85 mb-2">MEVCUT BAKİYENİZ</div>
        <div className="font-display text-5xl md:text-6xl font-black gold-text leading-none">{fmtMoney(balance)} ₺</div>
      </div>
      
      <div className="rounded-3xl border border-white/10 bg-gradient-to-b from-[#08080b] to-[#08080b] p-6 md:p-8 max-w-2xl">
        <h3 className="font-display text-xl font-bold text-white mb-6 flex items-center gap-2"><Banknote className="w-5 h-5 text-[#f4d896]" /> Bakiye Yükle</h3>
        <form onSubmit={submitDeposit} className="space-y-5">
          <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">YÜKLEME YÖNTEMİ</span>
            <div className="relative">
              <select value={method} onChange={e => setMethod(e.target.value)} className="w-full h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60 appearance-none">
                <option value="havale" className="bg-[#08080b]">Havale / EFT</option>
                <option value="kripto" className="bg-[#08080b]">Kripto (USDT/BTC)</option>
              </select>
            </div>
          </label>
          <div className="grid md:grid-cols-2 gap-5">
            <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">TUTAR (₺)</span>
              <input type="number" value={amount} onChange={e => setAmount(e.target.value)} required min="1" className="w-full h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" placeholder="Örn. 500" />
            </label>
            <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">İŞLEM NO / GÖNDEREN</span>
              <input type="text" value={txId} onChange={e => setTxId(e.target.value)} required className="w-full h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" placeholder="Ad Soyad veya TxID" />
            </label>
          </div>
          <button type="submit" className="mt-4 w-full md:w-auto btn-gold h-12 px-8 rounded-full inline-flex items-center justify-center gap-2 text-sm font-extrabold tracking-widest">
            YÜKLEME TALEBİ GÖNDER <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}

export function AccountDownloads() {
  const { authHeader } = useUserAuth();
  const [downloads, setDownloads] = useState([]);
  
  useEffect(() => {
    API.get('/user/downloads', { headers: authHeader() }).then(r => setDownloads(r.data));
  }, []);

  return (
    <div>
      <h2 className="font-display text-2xl font-black text-white mb-6">İndirmeler</h2>
      {downloads.length === 0 ? (
        <div className="py-12 text-center rounded-3xl border border-white/5 bg-white/[0.02]">
          <Download className="w-12 h-12 text-white/20 mx-auto mb-4" />
          <p className="text-white/60">İndirilebilir ürününüz bulunmuyor.</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {downloads.map((d, i) => (
            <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between p-6 rounded-3xl border border-white/8 bg-gradient-to-b from-[#08080b] to-[#08080b] hover:border-[#e4b44e]/30 transition group">
              <div className="mb-4 sm:mb-0">
                <div className="text-white font-bold text-lg mb-1">{d.name}</div>
                <div className="text-xs font-bold tracking-widest text-white/40">SİPARİŞ: #{d.order_id.slice(0,8)}</div>
              </div>
              <a href={API.defaults.baseURL + d.url} className="btn-gold h-10 px-6 rounded-full inline-flex items-center justify-center gap-2 text-xs font-extrabold tracking-widest">
                İNDİR <Download className="w-3.5 h-3.5" />
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function AccountServices() {
  const { authHeader } = useUserAuth();
  const [services, setServices] = useState([]);
  useEffect(() => { API.get('/user/services', { headers: authHeader() }).then(r => setServices(r.data)); }, []);

  return (
    <div>
      <h2 className="font-display text-2xl font-black text-white mb-6">Hizmetlerim</h2>
      {services.length === 0 ? (
        <div className="py-12 text-center rounded-3xl border border-white/5 bg-white/[0.02]">
          <User className="w-12 h-12 text-white/20 mx-auto mb-4" />
          <p className="text-white/60">Kayıtlı hizmetiniz bulunmuyor.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-5">
          {services.map((s, i) => (
            <div key={i} className="p-6 rounded-3xl border border-white/8 bg-gradient-to-b from-[#08080b] to-[#08080b] text-white">
               {s.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function AccountBilling() {
  const { authHeader } = useUserAuth();
  const [billing, setBilling] = useState({ name: '', address: '', city: '', tax_id: '', phone: '' });

  useEffect(() => { API.get('/user/billing', { headers: authHeader() }).then(r => { if(r.data) setBilling(r.data); }); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await API.put('/user/billing', billing, { headers: authHeader() });
      alert('Fatura bilgileri güncellendi.');
    } catch {
      alert('Hata!');
    }
  };

  return (
    <div>
      <h2 className="font-display text-2xl font-black text-white mb-6">Fatura Bilgileri</h2>
      <div className="rounded-3xl border border-white/10 bg-gradient-to-b from-[#08080b] to-[#08080b] p-6 md:p-8 max-w-2xl">
        <form onSubmit={submit} className="space-y-5">
          <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">FİRMA VEYA AD SOYAD</span>
            <input required value={billing.name||''} onChange={e=>setBilling({...billing, name: e.target.value})} className="w-full h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" />
          </label>
          <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">ADRES</span>
            <textarea required value={billing.address||''} onChange={e=>setBilling({...billing, address: e.target.value})} className="w-full p-4 rounded-2xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60 h-28" />
          </label>
          <div className="grid md:grid-cols-2 gap-5">
            <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">ŞEHİR</span>
              <input required value={billing.city||''} onChange={e=>setBilling({...billing, city: e.target.value})} className="w-full h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" />
            </label>
            <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">TELEFON</span>
              <input required value={billing.phone||''} onChange={e=>setBilling({...billing, phone: e.target.value})} className="w-full h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" />
            </label>
          </div>
          <label className="block"><span className="text-xs font-bold tracking-widest text-white/50 mb-2 block">VERGİ NO / TC KİMLİK NO</span>
            <input value={billing.tax_id||''} onChange={e=>setBilling({...billing, tax_id: e.target.value})} className="w-full h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" />
          </label>
          <button type="submit" className="mt-4 btn-gold h-12 px-8 rounded-full inline-flex items-center justify-center gap-2 text-sm font-extrabold tracking-widest">
            KAYDET <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}

export function Account2FA() {
  const { authHeader, user } = useUserAuth();
  const [data, setData] = useState(null);
  const [code, setCode] = useState('');

  const generate = () => {
    API.post('/user/2fa/generate', {}, { headers: authHeader() }).then(r => setData(r.data)).catch(e => alert(e.response?.data?.detail||'Hata'));
  };
  const verify = () => {
    API.post('/user/2fa/verify', { code }, { headers: authHeader() }).then(() => {
      alert('2FA başarıyla etkinleştirildi!');
      window.location.reload();
    }).catch(e => alert(e.response?.data?.detail || 'Hata'));
  };
  
  return (
    <div>
      <h2 className="font-display text-2xl font-black text-white mb-6">Güvenlik (2FA)</h2>
      <div className="rounded-3xl border border-white/10 bg-gradient-to-b from-[#08080b] to-[#08080b] p-6 md:p-10 max-w-2xl">
        {user?.['2fa_enabled'] ? (
          <div className="text-center py-8">
            <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">İki Aşamalı Doğrulama Aktif</h3>
            <p className="text-emerald-400/80 mb-6">Hesabınız maksimum güvenlik seviyesiyle korunuyor.</p>
            <p className="text-sm text-white/50">2FA'yı devre dışı bırakmak isterseniz lütfen destek talebi oluşturun.</p>
          </div>
        ) : (
          <>
            <div className="flex items-start gap-4 mb-8 p-4 rounded-2xl bg-[#e4b44e]/5 border border-[#e4b44e]/20">
              <ShieldAlert className="w-6 h-6 text-[#f4d896] shrink-0 mt-0.5" />
              <div>
                <h4 className="text-white font-bold mb-1">Hesabınızı Güvenceye Alın</h4>
                <p className="text-sm text-white/60 leading-relaxed">İki aşamalı doğrulama (2FA) etkinleştirildiğinde, giriş yaparken parolanızın yanı sıra telefonunuzdaki (Google Authenticator vb.) uygulamadan alınan özel bir koda da ihtiyacınız olur.</p>
              </div>
            </div>
            
            {!data ? (
              <button onClick={generate} className="btn-gold h-12 px-8 rounded-full font-extrabold tracking-widest text-sm inline-flex items-center gap-2">
                2FA KURULUMUNU BAŞLAT <ArrowRight className="w-4 h-4" />
              </button>
            ) : (
              <div className="space-y-8 animate-in fade-in zoom-in duration-500">
                 <div className="flex flex-col md:flex-row gap-8 items-center">
                   <div className="p-4 bg-white rounded-2xl shadow-xl shrink-0" dangerouslySetInnerHTML={{__html: data.qr_svg}} />
                   <div>
                     <h4 className="text-lg font-bold text-white mb-2">1. Karekodu Tarayın</h4>
                     <p className="text-sm text-white/60 mb-4">Google Authenticator uygulamasından yeni bir hesap ekleyerek yandaki karekodu tarayın veya aşağıdaki gizli anahtarı manuel olarak girin.</p>
                     <div className="px-4 py-3 rounded-xl bg-white/5 border border-white/10 inline-block text-sm">
                       <span className="text-white/50 mr-2">Gizli Anahtar:</span>
                       <strong className="text-[#f4d896] tracking-[0.2em]">{data.secret}</strong>
                     </div>
                   </div>
                 </div>
                 
                 <div className="border-t border-white/10 pt-8">
                   <h4 className="text-lg font-bold text-white mb-2">2. Kodu Doğrulayın</h4>
                   <p className="text-sm text-white/60 mb-4">Uygulamanızda üretilen 6 haneli kodu aşağıya girerek 2FA kurulumunu tamamlayın.</p>
                   <div className="flex gap-3 max-w-sm">
                     <input value={code} onChange={e=>setCode(e.target.value)} className="flex-1 h-12 px-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60 text-center tracking-[0.3em] font-bold" placeholder="000000" maxLength="6" />
                     <button onClick={verify} className="btn-gold h-12 px-8 rounded-full font-extrabold tracking-widest text-sm shrink-0">DOĞRULA</button>
                   </div>
                 </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
